import { useMemo } from 'react';
import css from './PlaceholderGradient.module.scss';

export const PlaceholderGradient = ({ id, blur = 0 }: { id?: number; blur?: number }) => {
  // Without an id, pick a random seed once on mount so the gradient is stable across re-renders.
  const num = useMemo(() => (id === undefined ? Math.random() * 1000000 : id), [id]);

  return (
    <div
      style={
        {
          '--my-lqip': String(num),
          filter: `blur(${blur}px)`,
        } as React.CSSProperties
      }
      className={css.lqip}
    />
  );
};
